class AverageReducer {
  constructor(rows) {
    this.rows = rows;
  }

  initialValue() {
    return 0;
  }

  reduce(result, value) {
    return result + (value / this.rows.length);
  }
}

export default AverageReducer;